.cardList {
  display: flex;
  flex-direction: column;
  gap: 3rem;
}
